import { render, staticRenderFns } from "./ybsbgtjList.vue?vue&type=template&id=4ce12028&scoped=true&"
import script from "./ybsbgtjList.vue?vue&type=script&lang=js&"
export * from "./ybsbgtjList.vue?vue&type=script&lang=js&"
import style0 from "./ybsbgtjList.vue?vue&type=style&index=0&id=4ce12028&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce12028",
  null
  
)

export default component.exports